import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { ReportService } from "../report.service";
import { UserService } from "src/app/_services";
import { CompanyService } from "src/app/app/company/company.service";
import { DictionaryService } from "src/app/dictionary/dictionary.service";
import { ActivatedRoute } from "@angular/router";
import { Floor } from "src/app/app/building/floor/floor.model";
import { Building } from "src/app/app/building/building.model";
import { ReportTaskService } from "../report-task/report-task.service";
import { ModalController, NavController } from "@ionic/angular";
import { Report } from "../report.model";
import { TranslateService } from "@ngx-translate/core";
import { ThisPlatform } from "src/app/_services/platform.service";
import { BuildingService } from "src/app/app/building/building.service";
import { ImagePreviewComponent } from "../../_component/image-preview/image-preview.component";

@Component({
  selector: "app-report",
  templateUrl: "./report.component.html",
  styleUrls: [
    "./report.component.scss",
    "./../../../_styles/ion-grid-box.scss",
  ],
})
export class ReportComponent implements OnInit {
  compareWith: any;
  reportId: string;
  /** Checks if user had permisions to change status  */
  statusChangeDisabled: boolean = true;

  @Input()
  statusVisable = true;

  @Output()
  deleteReport: EventEmitter<number> = new EventEmitter<number>();

  @Output()
  HTTPerror: EventEmitter<any> = new EventEmitter<any>();

  priorytetEnabledToChange = false;

  showStatusButtons: boolean = false;

  floorName: string;

  constructor(
    public reportServ: ReportService,
    public reportTaskServ: ReportTaskService,
    public buildingServ: BuildingService,
    public companyServ: CompanyService,
    public dictionaryServ: DictionaryService,
    public userServ: UserService,
    private route: ActivatedRoute,
    private navCtrl: NavController,
    public translateService: TranslateService,
    public p: ThisPlatform,
    public modalController: ModalController
  ) {}

  async ngOnInit() {
    this.reportServ.loading = true;
    await this.userServ.getPermision();

    this.route.paramMap.subscribe((paramMap) => {
      if (!paramMap.has("ReportId")) {
        this.navCtrl.navigateBack("/report");
        return;
      }

      this.reportId = paramMap.get("ReportId");

      this.reportServ.getReport(this.reportId).subscribe({
        next: (report: Report) => {
          this.reportServ.report = report;

          this.floorName = this.getFloorName();

          this.checkUpdateStatusPermisions();
          this.priorytetEnabledToChange = this.userServ.hasRoles([
            "report.edit.change-priority",
          ]);

          if (this.buildingServ.buildings.length === 0) {
            this.buildingServ
              .getBuildings()
              .subscribe((buildings: Building[]) => {
                this.buildingServ.buildings = buildings;
              });
          }

          this.companyServ
            .getUserBuildingFloors(this.reportServ.report.idBuilding)
            .subscribe((floors: Floor[]) => {
              this.companyServ.userFloors = floors;
            });
        },
        error: (error) => {
          this.HTTPerror.emit(error.status);
          this.reportServ.loading = false;
        },
        complete: () => {
          this.reportServ.loading = false;
        }
      });

      this.showStatusButtons = true; //hak konieczny do odpalenia przycisków statusu
    });
  }

  async onImagePreview($event, url) {
    $event.stopPropagation();
    $event.preventDefault();

    const modal = await this.modalController.create({
      component: ImagePreviewComponent,
      componentProps: { src: url },
      animated: true,
      cssClass: "image-preview-present",
    });
    modal.present();
  }

  /**
   * Gets flooro name
   * @returns floor name
   */
  getFloorName() {
    if (this.companyServ.userFloors && this.reportServ.report) {
      let floor = this.companyServ.userFloors.find(
        (f) => f.id === this.reportServ.report.idFloor
      );

      if (floor) return floor.name;
    }
  }

  /**
   * Sets status value
   * @param value selected status
   */
  selectedStatusChange(value: number) {
    //TODO open modal page to confirm status change
    this.reportServ.report.status = value;

    this.reportServ.updateReport().subscribe();
  }

  selectedPriorityChange(value: number) {
    //TODO open modal page to confirm status change
    this.reportServ.report.priority = value;

    this.reportServ.updateReport().subscribe();
  }

  checkUpdateStatusPermisions() {
    if (
      this.userServ.userStorage.id === this.reportServ.report.idUserCreatedBy ||
      this.userServ.hasRoles(["report.status.edit"])
    ) {
      this.statusChangeDisabled = false;
    }
  }

  onReportDelete() {
    this.deleteReport.emit();
  }
}
